module.exports = __webpack_public_path__ + "static/media/3.46f38047.jpg";